import { render, staticRenderFns } from "./TrEx.vue?vue&type=template&id=c280ffaa&scoped=true&"
import script from "./TrEx.vue?vue&type=script&lang=js&"
export * from "./TrEx.vue?vue&type=script&lang=js&"
import style0 from "./TrEx.vue?vue&type=style&index=0&id=c280ffaa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c280ffaa",
  null
  
)

export default component.exports